import { render, staticRenderFns } from "./PieChart.component.vue?vue&type=template&id=a08dd01e&scoped=true&"
import script from "./PieChart.component.vue?vue&type=script&lang=ts&"
export * from "./PieChart.component.vue?vue&type=script&lang=ts&"
import style0 from "./PieChart.component.vue?vue&type=style&index=0&id=a08dd01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08dd01e",
  null
  
)

export default component.exports